import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/storage";
import "firebase/auth";

const config = {
    apiKey: "AIzaSyD3iEyTz8pJ5aLX69sLWJH16AmyClVobcc",
    authDomain: "amalay-menu.firebaseapp.com",
    projectId: "amalay-menu",
    storageBucket: "amalay-menu.appspot.com",
    messagingSenderId: "420352475731",
    appId: "1:420352475731:web:4b50b03a6c45c7c3a6fca6"
  };

  firebase.initializeApp(config);
const auth = firebase.auth();

var db = firebase.firestore();
var storageRef = firebase.storage().ref();
const analytics = firebase.analytics();
const menuItems = db.collection("menuItems");
const menuTags = db.collection("tags");

export { auth, db, storageRef, menuItems, menuTags, analytics };